import { Badge } from "@knowtex-ai/components";
import { formatDate } from "./foiaUtils";

const WINDOW_BADGE = {
  inside: { label: "Inside window", variant: "success" },
  outside: { label: "Outside window", variant: "warning" },
};

function sortInsideWindowFirst(appointments) {
  const rank = (appointment) => (appointment.window === "inside" ? 0 : 1);
  return [...appointments].sort(
    (a, b) => rank(a) - rank(b) || new Date(a.date) - new Date(b.date)
  );
}

function IdCell({ value }) {
  return value ? <span className="font-mono text-xs text-gray-700">{value}</span> : <span className="text-gray-400">—</span>;
}

export default function FoiaAppointmentsPanel({ appointments }) {
  if (!appointments?.length) return null;

  return (
    <div className="mt-5 rounded-xl border border-gray-200 bg-white p-4">
      <h2 className="text-sm font-semibold text-gray-900">Appointments to retain</h2>
      <p className="mt-1 mb-3 text-sm text-gray-600">Retain the recording for each inside-window appointment.</p>
      <div className="overflow-x-auto">
        <table className="foia-match-table">
          <thead>
            <tr>
              <th>Appointment date</th>
              <th>Provider</th>
              <th>Window</th>
              <th>Appointment ID</th>
              <th>Patient ID</th>
            </tr>
          </thead>
          <tbody>
            {sortInsideWindowFirst(appointments).map((appointment) => {
              const windowBadge = WINDOW_BADGE[appointment.window];
              return (
                <tr key={appointment.id}>
                  <td>{formatDate(appointment.date)}</td>
                  <td>{appointment.provider || "Unknown provider"}</td>
                  <td>
                    {windowBadge ? (
                      <Badge variant={windowBadge.variant} size="small">
                        {windowBadge.label}
                      </Badge>
                    ) : (
                      <span className="text-gray-400">—</span>
                    )}
                  </td>
                  <td>
                    <IdCell value={appointment.matchedAppointmentId} />
                  </td>
                  <td>
                    <IdCell value={appointment.matchedPatientId} />
                  </td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  );
}
